import * as actionTypes from '../actions/actionTypes';

const initialState = {
    isAuthenticating: false,
    view: 'home',
    authFlow: 'login',
    loginError: false,
    loading: false,
    logout: true,
    authType: null,
    authValidityError: false,
    authValidityLoading: false,
    email: '',
    interactionIds: '',
    otpLoading: false,
    otpError: false,
    verifyOtp: false,
    loginOtp: false,
    resendOtp: false,
    otpMessage: '',
    loggingIn: false,
    userProfile: null,
    userProfileLoading: true,
    userProfileError: false,
    userPassport: null,
    userPassportLoading: true,
    userPassportError: false,
    passwordRecoveryLoading: false,
    passwordRecoveryError: false,
    resetPasswordLoading: false,
    resetPasswordError: false,
    isLoggedIn: false,
    logoutLoading: false,
    accountCreationError: false,
    userProductAccess: null,
    userProductAccessError: null,
    userHeaderMenu: null,
    userHeaderMenuError: null,
    userMarkup: null,
    userMarkupError: null,
    userBalance: null,
    userBalanceError: null,
    userBlockedAmount: null,
    userBlockedAmountError: null,
    userPaymentOptions: null,
    userPaymentOptionsError: null,
    userPaymentOptionsLoading: true,
    userBanners: null,
    userBannersError: null,
    flightRecentBooking: null,
    flightRecentBookingError: null,
    hotelRecentBooking: null,
    hotelRecentBookingError: null,
    ssoToken: null,
    agentHeaderData: null,
    agentFooterData: null
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_LOGIN_STATUS:
            return {
                ...state,
                isLoggedIn: action.val
            }
        case actionTypes.START_AUTHENTICATION:
            return {
                ...state,
                isAuthenticating: true
            }
        case actionTypes.STOP_AUTHENTICATION:
            return {
                ...state,
                isAuthenticating: false,
                otpLoading: false,
                authValidityLoading: false,
                loading: false,
                loggingIn: false,
                ssoToken: null
            }
        case actionTypes.SET_AUTH_VIEW:
            return {
                ...state,
                view: action.view,
                otpLoading: false,
                authValidityLoading: false,
                loading: false
            }
        case actionTypes.SET_OTP_LOADING:
            return {
                ...state,
                otpLoading: true
            }
        case actionTypes.GET_EMAIL_STATUS:
                let emailView = null;
                let emailFlow = null;
                let error = false;
                if (action.val === 'EMAIL_AVAILABLE') { 
                    emailView = 'home'; 
                    emailFlow = 'home';
                    error = true;
                } 
                else if (action.val === 'EMAIL_UNAVAILABLE') { 
                    emailView = 'login' 
                    emailFlow = 'login'
                }            
            return {
                ...state,
                email: action.email,
                authType: 'email',
                view: emailView,
                authFlow: emailFlow,
                authValidityLoading: false,
                authValidityError: error
            }
        case actionTypes.AUTH_VALIDITY_LOADING:
            return {
                ...state,
                authValidityLoading: true
            }
        case actionTypes.AUTH_VALIDITY_CHECK_FAILED:
            return {
                ...state,
                authValidityError: true,
                authValidityLoading: false
            }
        case actionTypes.SET_OTP:
            return {
                ...state,
                interactionIds: action.interactionIds,
                view: 'otp',
                ssoToken: action.ssoToken
            }
        case actionTypes.GET_OTP_FAILED:
            return {
                ...state,
                otpError: true,
                otpLoading: false
            }
        case actionTypes.SET_RESEND_OTP:
            return {
                ...state,
                resendOtp: true,
                otpLoading: false
            }
        case actionTypes.GET_RESEND_OTP_FAILED:
            return {
                ...state,
                resendOtp: false,
                otpError: true,
                otpLoading: false
            }
        case actionTypes.SET_VERIFY_OTP:
            return {
                ...state,
                otpLoading: false,
                loggingIn: false,
                isLoggedIn: true,
                isAuthenticating: false
            }
        case actionTypes.GET_VERIFY_OTP_FAILED:
            return {
                ...state,
                otpError: true,
                otpLoading: false
            }
        case actionTypes.NORMAL_LOGIN_START:
            return {
                ...state,
                loggingIn: true,
                loginError: false
            }
        case actionTypes.NORMAL_LOGIN_SUCCESS:
            return {
                ...state,
                otpLoading: false,
                loggingIn: false,
                isLoggedIn: true,
                isAuthenticating: false,
                ssoToken: action.ssoToken
            }
        case actionTypes.NORMAL_LOGIN_FAIL:
            return {
                ...state,
                loggingIn: false,
                loginError: true
            }
        case actionTypes.PASSWORD_RECOVERY_START:
            return {
                ...state,
                passwordRecoveryLoading: true,
                passwordRecoveryError: false
            }
        case actionTypes.PASSWORD_MAIL_SENT:
            return {
                ...state,
                view: 'forgotPasswordLink',
                passwordRecoveryLoading: false,
                passwordRecoveryError: false
            }
        case actionTypes.PASSWORD_MAIL_FAIL:
            return {
                ...state,
                passwordRecoveryLoading: false,
                passwordRecoveryError: true
            }
        case actionTypes.PASSWORD_RECOVERY_COMPLETED:
            return {
                ...state,
                isAuthenticating: true,
                view: 'resetCompleted',
                passwordRecoveryLoading: false,
                passwordRecoveryError: false
            }
        case actionTypes.PASSWORD_RECOVERY_FAILED:
            return {
                ...state,
                passwordRecoveryLoading: false,
                passwordRecoveryError: true
            }
        case actionTypes.LOGOUT_START:
            return {
                ...state,
                logoutLoading: true
            }
        case actionTypes.LOGOUT_SUCCESS:
            return {
                ...state,
                logoutLoading: false,
                isLoggedIn: false,
                isAuthenticating: false,
                view: 'home'
            }
        case actionTypes.LOGOUT_FAIL:
            return {
                ...state,
                logoutLoading: false
            }
        case actionTypes.SET_USER_PROFILE:
            return {
                ...state,
                userProfile: action.userProfile,
                userProfileLoading: false
            }
        case actionTypes.SET_USER_PROFILE_LOADING:
            return {
                ...state,
                userProfileLoading: true
            }
        case actionTypes.GET_USER_PROFILE_FAILED:
            return {
                ...state,
                userProfileError: true
            }
        case actionTypes.SET_PRODUCT_ACCESS:
            return {
                ...state,
                userProductAccess: action.val,
                userProductAccessError: false
            }
        case actionTypes.GET_PRODUCT_ACCESS_FAILED:
            return {
                ...state,
                userProductAccessError: true
            }
        case actionTypes.SET_HEADER_MENU:
            return {
                ...state,
                userHeaderMenu: action.val,
                userHeaderMenuError: false
            }
        case actionTypes.GET_HEADER_MENU_FAILED:
            return {
                ...state,
                userHeaderMenuError: true
            }
        case actionTypes.SET_MARKUP:
            return {
                ...state,
                userMarkup: action.val,
                userMarkupError: false
            }
        case actionTypes.GET_MARUKUP_FAILED:
            return {
                ...state,
                userMarkupError: true
            }
        case actionTypes.SET_BALANCE:
            return {
                ...state,
                userBalance: action.val,
                userBalanceError: false
            }
        case actionTypes.GET_BALANCE_FAILED:
            return {
                ...state,
                userBalanceError: true
            }
        case actionTypes.SET_BLOCKED_AMOUNT:
            return {
                ...state,
                userBlockedAmount: action.val,
                userBlockedAmountError: false
            }
        case actionTypes.GET_BLOCKED_AMOUNT_FAILED:
            return {
                ...state,
                userBlockedAmountError: true
            }
        case actionTypes.START_PAYMENT_OPTIONS_LOADING:
            return {
                ...state,
                userPaymentOptionsLoading: true
            }
        case actionTypes.STOP_PAYMENT_OPTIONS_LOADING:
            return {
                ...state,
                userPaymentOptionsLoading: false
            }
        case actionTypes.SET_PAYMENT_OPTIONS:
            return {
                ...state,
                userPaymentOptions: action.val,
                userPaymentOptionsError: false,
                userPaymentOptionsLoading: false
            }
        case actionTypes.GET_PAYMENT_OPTIONS_FAILED:
            return {
                ...state,
                userPaymentOptionsError: true
            }
        case actionTypes.SET_BANNERS:
            return {
                ...state,
                userBanners: action.val,
                userBannersError: false
            }
        case actionTypes.GET_BANNERS_FAILED:
            return {
                ...state,
                userBannersError: true
            }
        case actionTypes.SET_FLIGHT_RECENT_BOOKING:
            return {
                ...state,
                flightRecentBooking: action.val
            }
        case actionTypes.GET_FLIGHT_RECENT_BOOKING_FAILED:
            return {
                ...state,
                flightRecentBookingError: true
            }
        case actionTypes.SET_HOTEL_RECENT_BOOKING:
            return {
                ...state,
                hotelRecentBooking: action.val
            }
        case actionTypes.GET_HOTEL_RECENT_BOOKING_FAILED:
            return {
                ...state,
                hotelRecentBookingError: true
            }
        case actionTypes.SET_AGENT_HEADER:
            return {
                ...state,
                agentHeaderData: action.val
            }
        case actionTypes.SET_AGENT_FOOTER:
            return {
                ...state,
                agentFooterData: action.val
            }
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/auth.js